// @owners { team: patients }
import { DEFAULT_ERROR_ALERT_MESSAGE } from '~shared/constants';

export const ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE = `Unable to add medications to your upcoming delivery. ${DEFAULT_ERROR_ALERT_MESSAGE}`;

export const ADD_TO_UPCOMING_DELIVERY_SUCCESS_MESSAGE = 'Successfully added your medications to your upcoming delivery';
